module.exports = __webpack_public_path__ + "static/media/feature_8.4d544c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/feature_8.png
// module id = 1257
// module chunks = 0